export class Bounds {
  static fromGoogleBounds(bounds, label) {
    return new Bounds(
      bounds.getNorthEast().lat(),
      bounds.getNorthEast().lng(),
      bounds.getSouthWest().lat(),
      bounds.getSouthWest().lng(),
      label
    )
  }

  static fromParams(params, boundsLabel) {
    if (params) {
      const [north, east, south, west] = params.split(',')
      const label = decodeURIComponent(boundsLabel)
      return new Bounds(north, east, south, west, label)
    }
  }

  constructor(north, east, south, west, label) {
    this.north = north
    this.east  = east
    this.south = south
    this.west  = west
    this.label = label
  }

  // The world is round and 180/-180 actually means the same position. Our API
  // cannot translate these cases, b/c it performs plain float comparison.
  // This is why we got to cap the value to a maximum here.
  get cappedEast() {
    if (this.east <= 0 && this.west >= 0) {
      if (Math.abs(this.east) > Math.abs(this.west)) {
        return 180
      } else {
        return this.east
      }
    } else {
      return this.east
    }
  }

  // The world is round and 180/-180 actually means the same position. Our API
  // cannot translate these cases, b/c it performs plain float comparison.
  // This is why we got to cap the value to a maximum here.
  get cappedWest() {
    if (this.east <= 0 && this.west >= 0) {
      if (Math.abs(this.east) < Math.abs(this.west)) {
        return -180
      } else {
        return this.west
      }
    } else {
      return this.west
    }
  }

  toParams() {
    return `${this.north},${this.east},${this.south},${this.west}&boundsLabel=${this.label}`
  }
}
